<template>
	<div class="progress-slider container">
		<vue-slider ref="slider" v-bind="slider" v-model="slider.value"/>
	</div>
</template>

<script>
	const $ = window.$
	import vueSlider from 'vue-slider-component';

	export default {
		name: 'order-progress',
		props: ['stage', 'index', 'current'],
		components: {vueSlider},
		data() {
			return {
				slider: {
					value: 0,
					width: '100%',
					height: 10,
					dotSize: 0,
					min: 1,
					max: 6,
					interval: 1,
					disabled: false,
					show: true,
					speed: 0.3,
					reverse: false,
					lazy: true,
					tooltip: false,
					clickable: false,
					piecewise: true,
					piecewiseStyle: {
						left: 0
					},
					piecewiseLabel: true,
					processStyle: {
						'backgroundColor': '#36B37E',
						'z-index': '2'
					},
					data: [
						'',//filler
						'Plan',
						'Pickup/Delivery',
						'Checkout',
						''//filler
					]
				}
			};
		},
		mounted() {
			$('.vue-slider-component .vue-slider').css('background-color', '#eaeaea');
			$('.progress-slider .vue-slider-component.vue-slider-horizontal .vue-slider-piecewise-label').css({
				'top': '-300%',
				'color': 'gray',
				'font-weight': 600,
				'font-size': '9px'
			});
			this.$nextTick(function () {
				$('.vue-slider-piecewise-label').css({
					'left': '0',
					'font-size': 10
				});
				this.slider.value = this.stage;
				let labels = $('.vue-slider-piecewise-label').slice(1, -1);
				let current_page = this.current;
				labels.map(function () {
					if (($(labels).index(this) + 1) <= current_page) {
						$(this).css({'color': '#36B37E'});
						if (($(labels).index(this) + 1) < current_page) {
							// do nothing
						}
					}
				});
			});

		},
		methods: {},
		computed: {
			user() {
				return this.$store.getters.user;
			}
		}
	};
</script>

<style scoped lang="scss">

	.progress-slider {
		width: 100%;
		height: 10px;
		margin-top: 75px;
		text-align: center;
	}

</style>
